import { Validation } from '../password_validation_popover/password_validation_popover';

const DEFAULT_NUM_SECONDS = 10;

export class PhxRevealablePasswordController {
  private ngModel: string;
  private onHide?: () => void;

  private inputType: 'password' | 'text';
  private session: ng.IPromise<any>;
  private validations: Validation;
  private outOfFocus: boolean;
  private passwordRequired: boolean = true;
  public numSeconds: number;

  constructor(
    private $scope: ng.IScope,
    private $document: ng.IDocumentService,
    private $element: ng.IAugmentedJQuery,
    private $interval: ng.IIntervalService
  ) {
    this.inputType = 'password';
    this.numSeconds = this.numSeconds || DEFAULT_NUM_SECONDS;
  }

  $onInit(): void {
    this.$document.on('mousedown', (event) => {
      if (_.isFunction(this.onHide)) {
        this.onHide();
      }
    });

    this.$element.on('mousedown', (event) => {
      event.stopPropagation();
    });
  }

  hasText(): boolean {
    return !_.isEmpty(this.ngModel);
  }

  clearSession(): void {
    this.inputType = 'password';
    this.$interval.cancel(this.session);
    this.numSeconds = DEFAULT_NUM_SECONDS;
  }

  isInputTypeText(): boolean {
    return this.inputType === 'text';
  }

  isValid(): boolean {
    return _.all(this.validations);
  }

  showPassword(): void {
    this.clearSession();
    this.inputType = 'text';
    this.session = this.$interval(() => {
      this.numSeconds = this.numSeconds - 1;
      if (this.numSeconds <= 0) {
        this.clearSession();
      }
    }, 1000);
  }
}

angular
  .module('capability-ng-user-app')
  .controller('ngPhxRevealablePasswordController', PhxRevealablePasswordController)
  .component('phxRevealablePassword', {
    controller: 'ngPhxRevealablePasswordController',
    controllerAs: '$ctrl',
    templateUrl: 'lib/user_app/components/revealable_password/revealable_password.html',
    transclude: true,
    bindings: {
      numSeconds: '<?',
      onFocus: '&?',
      onBlur: '&?',
      onHide: '&?',
      onChange: '&?',
      ngModel: '=',
      form: '@',
      formLabel: '@',
      formAriaLabel: '@',
      placeholder: '@',
      name: '@',
      validations: '<?',
      passwordRequired: '<?',
      serverErrors: '<?'
    }
  });



// WEBPACK FOOTER //
// ./app/lib/user_app/components/revealable_password/revealable_password.ts